import { Component, Input, Output, EventEmitter } from '@angular/core';
import { CommonModule } from '@angular/common';
import { DOCUMENTS_INFO } from './data/step-six';

export type DocumentKey = keyof typeof DOCUMENTS_INFO;

@Component({
  selector: 'app-step-six',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './step-six.component.html',
  styleUrls: ['./step-six.component.scss']
})
export class StepSixComponent {
  @Input() documentosFirmados: { [key: string]: boolean } = {};
  @Input() aceptacionFinal: boolean = false;
  @Output() aceptacionFinalChange = new EventEmitter<boolean>();
  @Output() openDocument = new EventEmitter<{ documentType: string, documentTitle: string }>();

  DOCUMENTS_INFO = DOCUMENTS_INFO;

  onAceptacionChange(checked: boolean) {
    this.aceptacionFinalChange.emit(checked);
  }

  onOpenDocument(documentType: string, documentTitle: string) {
    this.openDocument.emit({ documentType, documentTitle });
  }

  getDocumentKeys(): DocumentKey[] {
    return Object.keys(this.DOCUMENTS_INFO) as DocumentKey[];
  }

  onCheckboxChange(event: Event) {
    const checked = (event.target as HTMLInputElement).checked;
    this.onAceptacionChange(checked);
  }
} 